/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
import { Grid, makeStyles } from '@material-ui/core';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useFormState } from 'react-final-form';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import QCXFormTitle from '../../components/form-title/QCXFormTitle';
import QCXRenderConditionalComponent from '../../components/catalogo-produtos/QCXRenderConditionalComponent';
import ValorInteiro from './components-fields/ValorInteiro';
import ValorReal from './components-fields/ValorReal';
import DominioDinamico from './components-fields/DominioDinamico';
import ListaEstatica from './components-fields/ListaEstatica';

const useStyles = makeStyles((theme) => ({
  gridFields: {
    paddingBottom: '16px',
  },
  twin: {
    [theme.breakpoints.up('sm')]: {
      paddingLeft: '16px',
    },
  },
  lastGridFields: {
    [theme.breakpoints.down('xs')]: {
      paddingBottom: '16px',
    },
  },
}));

const tiposCodigoParser = {
  'dominio dinamico': (metadado, combinacoesValidas = [], disabled) => (
    <DominioDinamico
      metadado={metadado}
      combinacoesValidas={combinacoesValidas}
      disabled={disabled}
      isConsult={false}
      basePath="ignorableFields.tratamentosTtce.metadados.valores"
    />
  ),
  'Lista Estática': (metadado, combinacoesValidas = [], disabled) => (
    <ValorInteiro
      metadado={metadado}
      disabled={disabled}
      isConsult={false}
      basePath="ignorableFields.tratamentosTtce.metadados.valores"
    />
  ),
  'Valor Inteiro': (metadado, combinacoesValidas = [], disabled) => (
    <ValorInteiro
      metadado={metadado}
      disabled={disabled}
      isConsult={false}
      basePath="ignorableFields.tratamentosTtce.metadados.valores"
    />
  ),
  'numero inteiro': (metadado, combinacoesValidas = [], disabled) => (
    <ValorInteiro
      metadado={metadado}
      disabled={disabled}
      isConsult={false}
      basePath="ignorableFields.tratamentosTtce.metadados.valores"
    />
  ),
  'Valor Real': (metadado, combinacoesValidas = [], disabled) => (
    <ValorInteiro
      metadado={metadado}
      disabled={disabled}
      isConsult={false}
      basePath="ignorableFields.tratamentosTtce.metadados.valores"
    />
  ),
};

export default function QCXAtributosTratamentoTributarioDuimp({
  intl,
  modes,
  submitSucceeded,
  parentModel,
  isRepasse = false,
  metadados,
}) {
  const { t } = useTranslation();
  const classes = useStyles();
  const { values } = useFormState();

  const listTratamentosTributarios = useMemo(() => metadados?.metadadosNormalizados || [], [metadados]);
  const combinacoesValidas = useMemo(() => metadados?.combinacoesValidas || [], [metadados]);

  const { isConsult, isSubNone, isSubConsult } = modes;

  return (
    <>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <QCXFormTitle title={'Atributos de Tratamento Tributario'.toUpperCase()} />
      </Grid>

      <Grid container>
        <Grid container spacing={2} style={{ marginTop: '1rem' }}>
          {listTratamentosTributarios != null &&
          Array.isArray(listTratamentosTributarios) &&
          listTratamentosTributarios.length ? (
            listTratamentosTributarios.map((metadado) => {
              const key = metadado.tipoCodigo
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase();
              const componenteFn = tiposCodigoParser[key];

              const component = componenteFn ? componenteFn(metadado, combinacoesValidas, isConsult) : null;

              if (!component) return null;

              return (
                <Grid key={metadado.codigo} item xs={12} sm={6} md={4}>
                  {component}
                </Grid>
              );
            })
          ) : (
            <Grid item>Nenhum atributo de fundamento legal disponível para esse fundamento selecionado !!</Grid>
          )}
        </Grid>
      </Grid>
    </>
  );
}
